import React from 'react';
import { IOpportunitiesTab } from './interfaces';
import { Tab } from '../../Tab';
import { useTranslation } from 'react-i18next';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

export const OpportunitiesTab: React.FC<IOpportunitiesTab> = ({
  label,
  ...other
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Tab
      label={label || t('tabs.opportunities')}
      icon={<TrendingUpIcon />}
      {...other}
    />
  );
};
